import { format, isValid, Locale, parseISO } from "date-fns"
import { nl } from "date-fns/locale"

export const DATE_PATTERNS = {
  // basis
  date: "dd/MM/yyyy", // 31/12/2025
  time: "HH:mm", // 14:30
  datetime: "dd/MM/yyyy HH:mm", // 31/12/2025 14:30

  // weekday-varianten
  weekdayNarrow: "EEEEE", // m, d, w ...
  weekdayShort: "EEEEEE", // ma, di, wo ...
  weekdayAbbr: "EEE", // maa, din, woe ...
  weekdayLong: "EEEE", // maandag, dinsdag ...
  dateWithWeekday: "EEEEEE dd/MM/yyyy",
  datetimeWithWeekday: "EEEEEE dd/MM/yyyy HH:mm", // maandag 31/12/2025 14:30
  weekdayLongDayMonth: "EEEE d MMMM", // maandag 1 januari

  day: "d", // 1
  day2digits: "dd", // 01
  dayMonthShort: "d MMM", // 1 jan
  dayMonthLong: "dd MMMM", // 01 januari
  longDate: "d MMMM yyyy", // 1 januari 2025
  weekdayLongDayMonthLong: "EEEE dd MMMM", // maandag 01 januari
  monthLongYear: "MMMM yyyy", // januari 2025

  // API-format
  api: "yyyy-MM-dd",
} as const

export type FormatKey = keyof typeof DATE_PATTERNS
export type FormatInput = Date | string | number | null | undefined

type FormatOptions = {
  locale?: Locale
  fallback?: string
}

// Discriminated union voor de 2e parameter
type PatternArg =
  | { format?: FormatKey } // key (optioneel; default = "date")
  | { pattern: string } // custom pattern expliciet

function toDate(value: FormatInput): Date | null {
  if (value == null) return null
  if (value instanceof Date) return isValid(value) ? new Date(value) : null
  if (typeof value === "string") {
    const iso = parseISO(value)
    if (isValid(iso)) return iso
    const d = new Date(value)

    return isValid(d) ? d : null
  }
  if (typeof value === "number") {
    const d = new Date(value)

    return isValid(d) ? d : null
  }

  return null
}

export function formatDateToDutch(
  value: FormatInput,
  arg: PatternArg = { format: "date" }, // default: dd/MM/yyyy
  opts: FormatOptions = {},
): string {
  const date = toDate(value)
  if (!date) return opts.fallback ?? ""

  const pattern =
    "pattern" in arg ? arg.pattern : DATE_PATTERNS[arg.format ?? "date"] // key is type-safe

  return format(date, pattern, { locale: opts.locale ?? nl })
}
